import type { QuestionThreadDto } from '@lib/dto/question.dto'
import { Tooltip } from '@/components/ui/tooltip'

export function QuestionDot({
  thread,
  selected,
  onSelect,
}: {
  thread: QuestionThreadDto
  selected: boolean
  onSelect: (id: string) => void
}) {
  return (
    <Tooltip content={thread.quote ?? 'Question'}>
      <button
        type="button"
        aria-label={thread.quote ? `Question near “${thread.quote}”` : 'Question'}
        className={`absolute h-3 w-3 -translate-x-1/2 -translate-y-1/2 rounded-full border border-attention bg-attention ${selected ? 'ring-2 ring-foreground' : ''}`}
        style={{ left: `${String(thread.x)}%`, top: `${String(thread.y)}%` }}
        onClick={(event) => {
          event.stopPropagation()
          onSelect(thread.id)
        }}
      />
    </Tooltip>
  )
}

export function DraftDot({ x, y }: { x: number; y: number }) {
  return (
    <span
      className="pointer-events-none absolute h-3 w-3 -translate-x-1/2 -translate-y-1/2 rounded-full border border-attention bg-attention/80"
      style={{ left: `${String(x)}%`, top: `${String(y)}%` }}
    />
  )
}
